import { render, staticRenderFns } from "./Uploaders.vue?vue&type=template&id=4a298f1a&scoped=true"
import script from "./Uploaders.vue?vue&type=script&lang=js"
export * from "./Uploaders.vue?vue&type=script&lang=js"
import style0 from "./Uploaders.vue?vue&type=style&index=0&id=4a298f1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a298f1a",
  null
  
)

export default component.exports